import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IRemoveTagFromFileParams {
  assignmentId: string;
}

export async function removeTagFromFile({
  assignmentId,
}: IRemoveTagFromFileParams): Promise<IApiResponse<null>> {
  const response = await fetcher(`drive-view/file/tag/${assignmentId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to remove tag',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
